import React, { useState, useEffect } from 'react';
import { Tree, Popover } from 'antd';
import { TextField, InputAdornment, IconButton, Box } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { useSelector } from 'dva';
import AntdTreeStyled from './AntdTreeStyles';

const generateList = (data1, fieldNames1) => {
  const dataList = [];
  const fun = (data, fieldNames) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      const key = node[`${fieldNames.key}`];
      const title = node[`${fieldNames.title}`];
      dataList.push({
        [`${fieldNames.key}`]: key,
        [`${fieldNames.title}`]: title,
      });
      if (node.children) {
        fun(node.children, fieldNames);
      }
    }
  };
  fun(data1, fieldNames1);
  return dataList;
};

const getParentKey = (key, tree, fieldNames) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item[`${fieldNames.key}`] === key)) {
        parentKey = node[`${fieldNames.key}`];
      } else if (getParentKey(key, node.children, fieldNames)) {
        parentKey = getParentKey(key, node.children, fieldNames);
      }
    }
  }
  return parentKey;
};

//根据选中的项查出所有的父级包括自己
const getTreeText = (data, key) => {
  const list = [];
  let str = '';
  const fun = (data1, key1) => {
    for (let i = 0; i < data1.length; i++) {
      const item = data1[i];
      if (item.id === key1) {
        list.push(item);

        fun(data, item.pid);
        break;
      } else {
        item.children && item.children.length > 0 && fun(item.children, key1);
      }
    }
  };
  fun(data, key);
  list.reverse();
  list.forEach((item, index) => {
    if (index !== list.length - 1) {
      str += item.name + '/';
    } else {
      str += item.name;
    }
  });
  return str;
};
export default ({
  fieldNames,
  treeData,
  endAdornment = null,
  selectValueSet,
  value = null,
  placeholder,
  errors,
  name,
  disabled,
  isNoSearch = false,
  icon = null,
  initExpandedKeys = null,
  minWidth = 300,
  treeNodeAdd,
  canVisibleChange = true,
}) => {
  const [expandedKeys, setExpandedKeys] = useState(null);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [status, setStatus] = useState(2); //2代表选择1搜索
  const [dataList, setDataList] = useState([]);
  const [visible, setVisibleChange] = React.useState(null);
  const [expandValue, setSelectExpandValue] = useState();
  const { treeDataRefresh } = useSelector((state) => state.labelManage);
  const loop = (data) => {
    if (data && data.length > 0) {
      return data.map((item) => {
        const index =
          status === 1
            ? item[`${fieldNames.title}`].indexOf(searchValue)
            : (searchValue || '')
                .split('/')
                .indexOf(item[`${fieldNames.title}`]);
        const beforeStr = item[`${fieldNames.title}`].substr(0, index);
        const afterStr = item[`${fieldNames.title}`].substr(
          index + searchValue.length,
        );
        const title =
          index > -1 && searchValue ? (
            isNoSearch ? (
              <span>
                {status === 1 && beforeStr}
                <span style={{ color: '#f50' }}>
                  {status === 2 ? item[`${fieldNames.title}`] : searchValue}
                </span>
                {status === 1 && afterStr}
              </span>
            ) : (
              <div className="label-between">
                <div>
                  {status === 1 && beforeStr}
                  <span style={{ color: '#f50' }}>
                    {status === 2 ? item[`${fieldNames.title}`] : searchValue}
                  </span>
                  {status === 1 && afterStr}
                </div>
                {treeNodeAdd ? (
                  <span
                    className="label-hover-hidden"
                    onClick={(e) => treeNodeAdd(e, item)}
                  >
                    +{' '}
                    <span style={{ fontSize: '12px', color: '#1565C0' }}>
                      添加子目录
                    </span>
                  </span>
                ) : (
                  ''
                )}
              </div>
            )
          ) : isNoSearch ? (
            <span>{item[`${fieldNames.title}`]}</span>
          ) : (
            <div className="label-between">
              {item[`${fieldNames.title}`]}
              {treeNodeAdd ? (
                <span
                  onClick={(e) => treeNodeAdd(e, item)}
                  className="label-hover-hidden"
                >
                  +{' '}
                  <span style={{ fontSize: '12px', color: '#1565C0' }}>
                    添加子目录
                  </span>
                </span>
              ) : (
                ''
              )}
            </div>
          );
        if (item.children) {
          return {
            title,
            key: item[`${fieldNames.key}`],
            children: loop(item.children),
          };
        }

        return {
          title,
          key: item[`${fieldNames.key}`],
        };
      });
    }
  };

  useEffect(() => {
    if (treeData && treeData.length > 0) {
      const list = generateList(treeData, fieldNames);
      setDataList(list);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeData]);
  const onChange = (e) => {
    const v = e.target.value;

    const keys = dataList
      .map((item) => {
        if (item[`${fieldNames.title}`].indexOf(v) > -1) {
          return getParentKey(item[`${fieldNames.key}`], treeData, fieldNames);
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);
    setSelectExpandValue(v ? keys : []);
    setAutoExpandParent(true);
    setSearchValue(v);
    if (!v) {
      selectValueSet([]);
    }
    setStatus(1);
  };
  const onExpand = (keys) => {
    setSelectExpandValue(keys);
    setAutoExpandParent(false);
  };
  const onSelect = (keys) => {
    if (keys.length === 0) {
      return;
    }
    selectValueSet(keys);

    setStatus(2);
  };

  useEffect(() => {
    setExpandedKeys(value ? [value] : []);
  }, [value]);

  useEffect(() => {
    if (treeData && expandedKeys) {
      const v = getTreeText(treeData, expandedKeys[0]);
      setSearchValue(v);
    }
  }, [expandedKeys, treeData, treeDataRefresh]);
  const handleVisibleChange = (v) => {
    !disabled && canVisibleChange && setVisibleChange(v);
  };

  const onFocus = () => {
    !disabled && setVisibleChange(true);
  };

  useEffect(() => {
    if (initExpandedKeys) {
      setSelectExpandValue(initExpandedKeys);
      console.log({ initExpandedKeys });
    }
  }, [initExpandedKeys, setSelectExpandValue]);
  if (isNoSearch) {
    return (
      <AntdTreeStyled>
        <Box className="antd-tree-popover-wrap">
          <Tree
            style={{ minWidth: minWidth + 'px' }}
            onSelect={onSelect}
            onExpand={onExpand}
            expandedKeys={expandValue}
            autoExpandParent={autoExpandParent}
            treeData={loop(treeData)}
            defaultSelectedKeys={expandedKeys ? expandedKeys : []}
            selectedKeys={expandedKeys ? expandedKeys : []}
            fieldNames={fieldNames}
            icon={icon}
            showIcon={true}
            blockNode
          />
        </Box>
      </AntdTreeStyled>
    );
  }
  return (
    <AntdTreeStyled>
      <Box className="antd-tree-popover-wrap">
        <Popover
          overlayClassName="popover-overlay-style"
          trigger="click"
          visible={visible}
          onVisibleChange={handleVisibleChange}
          placement="bottomLeft"
          getPopupContainer={() =>
            document.getElementsByClassName('antd-tree-popover-wrap')[0]
          }
          content={
            <Tree
              style={{ minWidth: '300px' }}
              onSelect={onSelect}
              onExpand={onExpand}
              expandedKeys={expandValue}
              autoExpandParent={autoExpandParent}
              treeData={loop(treeData)}
              defaultSelectedKeys={expandedKeys ? expandedKeys : []}
              selectedKeys={expandedKeys ? expandedKeys : []}
              fieldNames={fieldNames}
              blockNode
            />
          }
        >
          <TextField
            sx={{ width: '100%', height: 'auto' }}
            disabled={disabled}
            variant="standard"
            autoComplete="off"
            onChange={onChange}
            value={searchValue}
            onClick={onFocus}
            placeholder={placeholder}
            error={errors && Boolean(errors[name])}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    className="clear-btn"
                    onClick={() => {
                      setSearchValue('');
                      selectValueSet('');
                    }}
                    edge="end"
                    disabled={disabled}
                  >
                    {(searchValue || (value && value.length > 0)) && (
                      <ClearIcon className="clear-icon" />
                    )}
                  </IconButton>
                  {endAdornment && (
                    <span
                      style={{
                        fontSize: '12px',
                        color: '#404041',
                        marginLeft: '4px',
                      }}
                    >
                      {endAdornment}
                    </span>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Popover>
      </Box>
    </AntdTreeStyled>
  );
};
